export default __webpack_public_path__ + "static/media/5.68e3a571.jpg";